import { createFileRoute } from '@tanstack/react-router';

// Componente vem de config.lazy.tsx (code-splitting por rota, D4/DEC-060).
export const Route = createFileRoute('/config')({});
